<template>
  <div
    id="loyalty-use"
    class="mobile-card-select d-sm-none profile-account show"
  >
    <div class="select-card p-0 mb-0">
      <div class="checkout-card px-0">
        <div class="back-cart">
          <router-link :to="{ name: 'profile' }" class="back-account">
            <img src="/images/svg/global/left_arrow.svg" alt="" />
          </router-link>
        </div>
        <h4>{{ _T('How to Use Loyalty Point') }}</h4>
        <div class="default-according loyalty-accordion" id="accordionoc">
          <h4>{{ _T('Coming soon') }}...</h4>
          <!-- <div class="card">
            <div class="card-header py-0">
              <h5 class="mb-0">
                <button
                  class="btn btn-link txt-white"
                  data-toggle="collapse"
                  data-target="#collapseicon"
                  aria-expanded="true"
                  aria-controls="accordionoc"
                >
                  <i class="icofont icofont-briefcase-alt-2"></i> How You Can
                  Earn Point
                </button>
                {{ _T('Coming soon') }}...
              </h5>
            </div>
             <div
              class="collapse show"
              id="collapseicon"
              aria-labelledby="collapseicon"
              data-parent="#accordionoc"
            >
              <div class="card-body">
                <p>
                  Each <span class="font-primary">AED 500.00</span> from your
                  order transaction you will get 5 Point Cashback
                </p>
              </div>
            </div> 
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'HowToUseLoyalty',
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style></style>
